import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
  SignedInGuard,
  AdminRoleGuard
} from './guards';

import {
  AuctionsLayoutComponent
} from './shared/layouts';

import {
  PageHomeComponent,
  PageLoginComponent,
  PageForgotPasswordComponent,
  PageRegisterComponent,
  PageProfileComponent,
  PageAboutHistoryComponent,
  PageAboutStaffComponent,
  PageAboutTermsComponent,
  PageChangePasswordComponent
} from './pages'

const routes: Routes = [
  { path: '', component: PageHomeComponent, data: { title: '', pageRef: 'Z01', hideBanner: true } },
  { path: 'account', component: PageProfileComponent, data: { title: 'Account', pageRef: 'A01', hideBanner: true }, canActivate: [SignedInGuard] },
  { path: 'change-password', component: PageChangePasswordComponent, data: { title: 'Change Password', pageRef: 'A02', hideBanner: true }, canActivate: [SignedInGuard] },
  { path: 'login', component: PageLoginComponent, data: { title: 'Login', pageRef: 'Z01', hideBanner: true } },
  { path: 'login/:status', component: PageLoginComponent, data: { title: 'Login', pageRef: 'Z05', hideBanner: true } },
  { path: 'login-token/:uniqueToken', component: PageLoginComponent, data: { title: 'Token Login', pageRef: 'Z04', hideBanner: true } },
  { path: 'reset-password', component: PageForgotPasswordComponent, data: { title: 'Reset Password', pageRef: 'Z02', hideBanner: true } },
  { path: 'reset-password/:token', component: PageForgotPasswordComponent, data: { title: 'Reset Password', pageRef: 'Z03', hideBanner: true } },
  { path: 'register', component: PageRegisterComponent, data: { title: 'Register', pageRef: 'Z06', hideBanner: true } },
  { path: 'about/history', component: PageAboutHistoryComponent, data: { title: 'About - History', pageRef: 'AB01', hideBanner: true } },
  { path: 'about/staff', component: PageAboutStaffComponent, data: { title: 'About - Staff', pageRef: 'AB02', hideBanner: true } },
  { path: 'about/terms-conditions', component: PageAboutTermsComponent, data: { title: 'About - Terms and Conditions', pageRef: 'AB03', hideBanner: true } },

  // Admin Module
  { path: 'auction', component: AuctionsLayoutComponent, loadChildren: () => import('./auction/auction.module').then(m => m.AuctionModule) },
  { path: 'bids', component: AuctionsLayoutComponent, loadChildren: () => import('./bid/bid.module').then(m => m.BidModule) },
  { path: 'invoices', component: AuctionsLayoutComponent, loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule), canActivate: [SignedInGuard] },
  { path: 'remittances', component: AuctionsLayoutComponent, loadChildren: () => import('./remittance/remittance.module').then(m => m.RemittanceModule), canActivate: [SignedInGuard] },

  { path: '**', component: PageHomeComponent, data: { title: 'Not Found', pageRef: 'P404', hideBanner: true } },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
